var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { QuestionComponent, QuestionProps } from '@declaration/question';
import { LEAKAGE_CAUSE_LOCATION_HOUSE_OPTIONS } from '@declaration/constants/waterDamageConstants';
import QuestionPanel from '@declaration/components/UI/QuestionPanel.vue';
import RadioPrimaryButton from '@declaration/components/UI/RadioPrimaryButton.vue';
import { INSURER_CONFIG } from '@shared/insurer';
import { InsurerFeatureFlag, insurerHasFeature } from '@shared/featureFlags/insurerFeatureFlags';
const claim = namespace('claim');
const qualification = namespace('qualification');
const contract = namespace('contract');
let LeakageCauseLocationHouseQuestion = class LeakageCauseLocationHouseQuestion extends QuestionComponent {
    updateClaim(leakageCauseLocationHouse) {
        this.updateAndSaveWaterDamageQualification({
            qualificationPayload: {
                leakageCauseLocationHouse,
                leakageCauseDetailSlug: null,
                leakageCauseEquipmentSlug: null,
                leakageCauseRoomSlug: null,
            },
            step: this.step,
        });
    }
    get answer() {
        if (!this.waterDamageQualification.leakageCauseLocationHouse) {
            return null;
        }
        return LEAKAGE_CAUSE_LOCATION_HOUSE_OPTIONS[this.waterDamageQualification.leakageCauseLocationHouse]
            ? this.$tc(LEAKAGE_CAUSE_LOCATION_HOUSE_OPTIONS[this.waterDamageQualification.leakageCauseLocationHouse].answerTradKey)
            : null;
    }
    get hideHelpLink() {
        return insurerHasFeature(InsurerFeatureFlag.HideHelpLink);
    }
    get showHelpLink() {
        var _a, _b;
        if (this.hideHelpLink &&
            ((_b = (_a = INSURER_CONFIG.declaration.pages) === null || _a === void 0 ? void 0 : _a.leakageCauseLocationHouse) === null || _b === void 0 ? void 0 : _b.showHelpLink) === false) {
            return false;
        }
        return true;
    }
    get leakageCauseLocationHouseOptions() {
        return Object.values(LEAKAGE_CAUSE_LOCATION_HOUSE_OPTIONS);
    }
};
__decorate([
    claim.State('isUpdatingClaim')
], LeakageCauseLocationHouseQuestion.prototype, "isUpdatingClaim", void 0);
__decorate([
    qualification.State('qualification')
], LeakageCauseLocationHouseQuestion.prototype, "waterDamageQualification", void 0);
__decorate([
    qualification.Action('updateAndSaveQualification')
], LeakageCauseLocationHouseQuestion.prototype, "updateAndSaveWaterDamageQualification", void 0);
__decorate([
    contract.State('selectedContract')
], LeakageCauseLocationHouseQuestion.prototype, "selectedContract", void 0);
LeakageCauseLocationHouseQuestion = __decorate([
    Component({
        components: { RadioPrimaryButton, QuestionPanel },
        props: QuestionProps,
    })
], LeakageCauseLocationHouseQuestion);
export default LeakageCauseLocationHouseQuestion;
